module.exports = __webpack_public_path__ + "static/media/bot_avatar_1654_1.26e1da41.jpg";